// extracted by mini-css-extract-plugin
module.exports = {"content":"src-pages-guide-component-TaxAuthProtocol-protocol-AuthProtocol-SCProtocolContent-__index__content--2IVmJ"};